import React from 'react';

import { View } from '@fhs-legacy/universal-components';

const PageWrapper: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <View flex={1}>{children}</View>;
};

export default PageWrapper;
